import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

function LabeledLinearProgress(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={1}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box minWidth={35}>
        <Typography variant="body2" color="textSecondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles({
  root: {
    width: '100%',
    '& .MuiLinearProgress-root': {
      height: '20px',
      borderRadius: '10px',
      backgroundColor: 'rgb(220, 220, 220)',
    },
    '.MuiTypography-root': {
      fontSize: '18px',
      fontWeight: '600',
    },
  },
});

export default function LinearProgressWithLabel({ progress }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <LabeledLinearProgress value={progress} />
    </div>
  );
}
